var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFilter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25 25.01"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 224480"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Stroke 1",
  d: "M2.587.5A2.1 2.1 0 0 0 .5 2.621v1.248A3.4 3.4 0 0 0 1.419 6.2l6.461 6.87h0a6.876 6.876 0 0 1 1.949 4.8v6.1a.53.53 0 0 0 .78.475l3.679-2a1.745 1.745 0 0 0 .9-1.533v-3.063a6.87 6.87 0 0 1 1.928-4.783L23.582 6.2a3.4 3.4 0 0 0 .918-2.331V2.621A2.1 2.1 0 0 0 22.415.5Z",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))));
export default SvgFilter;